import { Box } from '@eneco/sparky';
import { BoxProps } from '@eneco/sparky/types';

import { horizontalRuleClass } from './HorizontalRule.css';

export const HorizontalRule = ({ backgroundColor }: { backgroundColor: BoxProps['backgroundColor'] }) => {
  return <Box backgroundColor={backgroundColor} className={horizontalRuleClass}> </Box>;
};
